import { FaXmark } from "react-icons/fa6";
import './VoterSyncPopup.css'
import { useNavigate } from "react-router-dom";
import { Fade, Slide, Zoom } from "react-awesome-reveal";

const VoterSyncPopup = ({
  handleClose
}) => {
  const navigate = useNavigate()

  return <>
    <div className="vs-launch-bg">
    </div>
    <div className="vsl-main-content p-3s w-[350px] sm:w-[880px] h-[550px]">
      <div className="absolute right-[-0] top-[0] p-3 bg-white text-black">
        <FaXmark className="cursor-pointer hover:scale-[1.2]" onClick={() => handleClose(null)} />
      </div>
      <div className="vsl-content relative top-[14px] left-[10%] sm:left-[50px] w-[75%] sm:w-[60%]">
        <div className="vsl-title text-xl sm:text-4xl font-light italic text-pink-800 text-left relative max-sm:left-[20px] max-sm:top-[20px]">
          We are launching...
        </div>
        <div className="vsl-product-title ">
          <div className="vsl-product-name mt-2 text-blue-900 text-5xl sm:text-7xl text-center font-bold leading-[1.7]">
            <Slide direction="up" damping={0}>
              VoterSync
            </Slide>
          </div>
          <div className="text-center text-sm sm:text-lg bg-blue-900 text-white tracking-wider">
            <Fade damping={6000}>
            The complete Voter Management System
            </Fade>
          </div>
        </div>
        <div className="vsl-points poppins-regular mt-5 text-sm sm:max-lg:text-md lg:text-lg ">
          <Fade damping={7000}>

          <div className="font-[cursive] text-blue-900 text-lg sm:text-2xl ">
            Our product includes :
          </div>
          <ul className="mt-1 relative left-[17px]">
            <li>
                Easy Voter registration
            </li>
            <li>
              Well organised Voter databases
              </li>
            <li>
              Report generation facilities
              </li>
            <li>
              Track Voter works, appointments, audits etc.
            </li>
            <li>Simple user interface</li>
          </ul>
          </Fade>

        </div>
        <div className="mt-3">
          <div className="vsl-know-more text-blue-800 underline text-lg sm:text-2xl hover:text-blue-400 w-fit cursor-pointer"
            onClick={e => {
              navigate('products/votersync')
              handleClose()
            }}
          >
            Know more
          </div>
        </div>
      </div>
    </div>
  </>
}

export default VoterSyncPopup;